// Termin-Akte in der CRM-Leiste (Phase 2.E): Bob fasst alle Mails zur Einrichtung für den Termin zusammen,
// jede Aussage mit Link zur Quell-Mail. Gecacht bis zur nächsten neuen Mail; „neu erzeugen“ erzwingt.
import { useState } from 'react';
import { api, ApiError, type TerminAkte } from '../lib/api.ts';
import { toast } from './Toast.tsx';
import { markdownHtml } from '@mail/shared';

export function TerminAkteBlock({ eventId }: { eventId: string }) {
  const [state, setState] = useState<'zu' | 'laden' | 'offen'>('zu');
  const [akte, setAkte] = useState<TerminAkte | null>(null);
  const load = async (frisch = false) => {
    setState('laden');
    try {
      setAkte(await api.terminAkte(eventId, frisch));
      setState('offen');
    } catch (e) {
      toast(e instanceof ApiError ? e.message : 'Termin-Akte nicht verfügbar');
      setState('zu');
    }
  };
  if (state === 'zu')
    return (
      <button className="btn sm" onClick={() => void load()} style={{ marginTop: 4 }}>
        ✦ Termin-Akte
      </button>
    );
  if (state === 'laden')
    return (
      <div className="callout bobsum" style={{ marginTop: 4 }}>
        <span className="spin" /> Bob liest alle Mails zur Einrichtung …
      </div>
    );
  return (
    <div className="akte">
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
        <b style={{ fontSize: 12 }}>✦ Termin-Akte</b>
        <span className="muted" style={{ fontSize: 11.5 }}>
          {akte?.mails ?? 0} Mails · {akte?.gecacht ? 'aus dem Zwischenspeicher' : 'neu erzeugt'}
        </span>
        <span className="sp" />
        <button className="btn sm ghost" onClick={() => void load(true)} title="Neu erzeugen">
          ↻
        </button>
        <button className="btn sm ghost" onClick={() => setState('zu')} title="Schließen">
          ✕
        </button>
      </div>
      <div
        className="akte-md"
        dangerouslySetInnerHTML={{ __html: markdownHtml(akte?.markdown ?? '') }}
      />
    </div>
  );
}
